import React from 'react';
import { EOrderTab } from '../../../../store/ducks/long-steel-orders/types';
import { Modal } from '@gerdau/hefesto';

import { ModalOverlay } from './styles';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { updateQueryParam } from '../../../../utils/updateQueryParams';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import moment from 'moment';

export const OrderCancelFinished = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const status = params.get('cancel') === 'finished';

  if (!status) {
    return null;
  }

  const updateItemsState = useSelector(
    (state: ApplicationState) => state.newLongSteelOrders.updateItems
  );

  const dispatch = useDispatch();
  const ordersState = useSelector(
    (state: ApplicationState) => state.newLongSteelOrders
  );
  const customersState = useSelector(
    (state: ApplicationState) => state.customers
  );

  React.useEffect(() => {
    dispatch(
      sendTagging({
        event: 'solicitacao_cancelamento_enviada',
        screenName: 'LG:MeusPedidos',
        itemDescription: 'meus_pedidos_acosLongos',
        estado_emissor:
          ordersState[
            ordersState.tableType || EOrderTab.OPEN
          ].initialInputValues.states.join(', '),
        emissor_pedido: customersState.customers
          .filter((item) =>
            ordersState[
              ordersState.tableType || EOrderTab.OPEN
            ].initialInputValues.emitterIds.includes(item.customerId)
          )
          .map((item) => item.name)
          .join(', '),
        data_inicio: moment(
          ordersState[ordersState.tableType || EOrderTab.OPEN]
            .initialInputValues.startDate
        ).format('DD/MM/YYYY'),
        data_fim: moment(
          ordersState[ordersState.tableType || EOrderTab.OPEN]
            .initialInputValues.endDate
        ).format('DD/MM/YYYY')
      })
    );
  }, []);

  const handleClose = () => {
    return updateQueryParam('cancel');
  };

  return (
    <ModalOverlay width={368}>
      <Modal
        title={`Sua solicitação de cancelamento de ${
          updateItemsState.itemsAllowed.length
        } ite${
          updateItemsState.itemsAllowed.length > 1 ? 'ns' : 'm'
        } foi enviada`}
        modalSize="sm"
        buttons={{
          right: {
            name: 'button-close-finished-items-update',
            children: 'Fechar',
            onClick: handleClose,
            type: 'button'
          }
        }}
      >
        <span>
          Sua solicitação de cancelamento será analisada e respondida por e-mail
          em até 3 dias úteis.
        </span>
      </Modal>
    </ModalOverlay>
  );
};
